import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { t } from '../../../../modules/infra/i18n';

const BarberLocations = ({
  locations,
  columnContainerRef,
  locationsStringRef,
  canExpandIsOn,
  expandedIsOn,
  onExpand,
}) => (
  <div
    className="c-table-card__cell u-visible-table-cell-for-large-and-up u-3/10"
    display-if={locations.length}
  >
    <div
      ref={columnContainerRef}
      className="is-not-scrollable u-position-relative"
    >
      <div ref={locationsStringRef} className="u-inline-flex u-mv-">
        <div className="c-counter-badge u-mr-">{locations.length}</div>
        <div
          className={classnames({ 'u-nowrap': !expandedIsOn })}
        >
          {locations.map(location => location.name).join(', ')}
        </div>
      </div>
      <button
        className="c-btn c-btn--blank c-show-more-button"
        display-if={canExpandIsOn && !expandedIsOn}
        onClick={onExpand}
      >
        {t('barber:locations.show_more')}
      </button>
    </div>
  </div>
);

BarberLocations.propTypes = {
  locations: PropTypes.array,
  columnContainerRef: PropTypes.object,
  locationsStringRef: PropTypes.object,
  canExpandIsOn: PropTypes.bool.isRequired,
  expandedIsOn: PropTypes.bool.isRequired,
  onExpand: PropTypes.func.isRequired,
};

BarberLocations.defaultProps = {
  locations: [],
  columnContainerRef: null,
  locationsStringRef: null,
};

export default BarberLocations;
